import StateModel from "Compare/store/models/stateModel";

const getters = {
	/** @param {StateModel} state */
	itemCount: state => {
		return state.products.length;
	},
	items: state => {
		return state.products;
	},
	uniqueTraits: state => {
		let allTraits = [];
		state.products.forEach((product) => {
			allTraits = allTraits.concat(product.productTraits);
		});

		let result = [];
		allTraits.forEach((trait) => {
			let existTrait = result.find((exist) => {
				return exist.id === trait.traitId;
			});

			if (existTrait === undefined)
				result.push({ id: trait.traitId, name: trait.name });
		});

		return result;
	}
};
export { getters };